import React, { createContext, PureComponent } from 'react';
import { ISelectedMethodContext } from '../types/SelectedMethodContext';
import { SelectPaymentMethodChangeStatus } from '../config/config';

interface IProps {
  children: JSX.Element;
}

const initialValue = {
  isSelectedPaymentMethodDisabled: false,
  selectedPaymentMethodDisabledReason: undefined,
  selectPaymentMethodChangeStatus: undefined,
};

export const SelectedMethodContext = createContext<Partial<ISelectedMethodContext>>(initialValue);

export class SelectedMethodContextProvider extends PureComponent<IProps, Partial<ISelectedMethodContext>> {
  constructor(props: IProps | Readonly<IProps>) {
    super(props);
    this.state = {
      isSelectedPaymentMethodDisabled: false,
      selectedPaymentMethodDisabledReason: undefined,
      selectPaymentMethodChangeStatus: undefined,
    };
  }

  setSelectedPaymentMethodChange = (selectPaymentMethodChangeStatus: SelectPaymentMethodChangeStatus) => {
    this.setState({ selectPaymentMethodChangeStatus });
  };

  setSelectedPaymentMethodDisabledAndReason = (
    isSelectedPaymentMethodDisabled,
    selectedPaymentMethodDisabledReason
  ) => {
    this.setState({ isSelectedPaymentMethodDisabled, selectedPaymentMethodDisabledReason });
  };

  render() {
    const { Provider } = SelectedMethodContext;
    const { children } = this.props;
    return (
      <Provider
        value={{
          ...this.state,
          setSelectedPaymentMethodDisabledAndReason: this.setSelectedPaymentMethodDisabledAndReason,
          setSelectedPaymentMethodChange: this.setSelectedPaymentMethodChange,
        }}
      >
        {children}
      </Provider>
    );
  }
}
